import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
const ThemeContext = createContext({
    theme: 'system',
    resolvedTheme: 'dark',
    setTheme: () => undefined,
});
export function useTheme() {
    return useContext(ThemeContext);
}
export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => {
        const stored = localStorage.getItem('legalis-theme');
        return stored ?? 'system';
    });
    const getSystemTheme = () => window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    const resolvedTheme = theme === 'system' ? getSystemTheme() : theme;
    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove('light', 'dark');
        root.classList.add(resolvedTheme);
    }, [resolvedTheme]);
    useEffect(() => {
        if (theme !== 'system')
            return;
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = () => {
            document.documentElement.classList.remove('light', 'dark');
            document.documentElement.classList.add(getSystemTheme());
        };
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [theme]);
    const setTheme = (t) => {
        localStorage.setItem('legalis-theme', t);
        setThemeState(t);
    };
    return (_jsx(ThemeContext.Provider, { value: { theme, resolvedTheme, setTheme }, children: children }));
}
//# sourceMappingURL=ThemeProvider.js.map